module.exports = __webpack_public_path__ + "static/media/3.c194be24.jpg";